import React, { useEffect, useState } from "react";
import TopNavBar from "../../layouts/topNavBar";
import SideNavBar from "../../layouts/sideNavBar";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { IMAGE_PROXY_URL, POST_UPLOAD_DOCUMENTS } from "../../services/Api";
import axios from "axios";
import { DOC_UPLOAD_SUCCESS } from "../../redux/Documents/doc.actionTypes";
import Microtext from "./pop-ups/microtext";
import Watermark from "./pop-ups/watermark";
import mammoth from "mammoth";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import DocFooter from "../../reusable_components/docFooter";
import jsPDF from "jspdf";
import Loader from "../../services/loader";
import html2canvas from "html2canvas";
import DashboardSidebar from "./dashboardSidebar";
import { PDFDocument } from "pdf-lib";

export default function FinalSubmit() {
  pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(
    new Blob([pdfWorker], { type: "application/javascript" })
  );

  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const store = useSelector((state) => state);

  const responseData = state?.response;
  const fileData = state?.fileData;
  const [isActive, setIsActive] = useState("");
  const [permission, setPermission] = useState("Private");

  const [selectMicrotext, setSelectMicrotext] = useState(false);
  const [selectWatermark, setSelectWatermark] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [isPDF, setIsPDF] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [finalDocUrl, setFinalDocUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const userNameStore = useSelector(
    (store) => store?.AuthManager?.userDetail?.userdetail?.name
  );

  useEffect(() => {
    if (fileData) {
      const fileName = fileData.file.name;
      const file = fileData.file;
      if (fileName.endsWith(".pdf")) {
        setIsPDF(true);
        renderPDF(file);
      } else if (fileName.endsWith(".docx") || fileName.endsWith(".doc")) {
        setIsImage(false);
        setIsPDF(false);
        renderWord(file);
      } else {
        setPreviewImage(URL.createObjectURL(file));
        setIsImage(true);
      }
    }
  }, [fileData]);

  // Convert image file to Base64 array format to match with the pdf format
  useEffect(() => {
    if (fileData?.file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        const formatted = `data:image/png;base64,${base64String}`;
        setPreviewImage([formatted]); //
      };
      reader.readAsDataURL(fileData.file);
    }
  }, [fileData]);

  const renderPDF = async (file) => {
    setFinalDocUrl(null);
    const pdfData = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;

    const pages = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const scale = 2;
      const viewport = page.getViewport({ scale });

      // Prepare canvas for rendering the PDF page
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render the PDF page into the canvas context
      await page.render({ canvasContext: context, viewport }).promise;

      // Convert canvas to data URL
      const imgData = canvas.toDataURL();
      pages.push(imgData); // Store each page as an image
    }

    setPreviewImage(pages); // Set all pages as images
  };

  const renderWord = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    mammoth
      .convertToHtml({ arrayBuffer })
      .then((result) => {
        const html = result.value;
        setPreviewImage(html);
      })
      .catch((err) => {
        console.error("Error rendering Word document:", err);
      });
  };

  const handleMicrotextClick = () => {
    setSelectWatermark(false);
    setSelectMicrotext(true);
  };

  const handleWatermarkClick = () => {
    setSelectWatermark(true);
    setSelectMicrotext(false);
  };

  const handleActive = (privacy) => {
    setIsActive(privacy);

    // Close the dropdown after one option gets selected
    const dropdownMenu = document.querySelector(".dropdown-menu--privacy");
    if (dropdownMenu) {
      dropdownMenu.classList.remove("show");
    }
  };

  useEffect(() => {
    if (state) {
      const value = state?.data1?.permission;
      value && setPermission(value);
    }
  }, [state]);

  const handleRemoveOption = (e) => {
    e.preventDefault();
    setSelectMicrotext(false);
    setSelectWatermark(false);
    setFinalDocUrl(null);
  };

  async function fetchQR(dynamicQrcode) {
    const res = await fetch(`${IMAGE_PROXY_URL}/media/${dynamicQrcode}`);
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // base64 string
      reader.readAsDataURL(blob);
    });
  }

  //   async function fetchQR(dynamicQrcode) {
  //   try {
  //     const res = await fetch(`${IMAGE_PROXY_URL}/media/${dynamicQrcode}`);
  //     if (!res.ok) {
  //       throw new Error(`HTTP error! status: ${res.status}`);
  //     }
  //     const blob = await res.blob();
  //     return new Promise((resolve) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => resolve(reader.result); // base64 string
  //       reader.readAsDataURL(blob);
  //     });
  //   } catch (error) {
  //     console.error("Error fetching QR code:", error);
  //     throw error; // rethrow or handle as needed
  //   }
  // }

  console.log(previewImage, finalDocUrl);

  const renderFooterCanvas = async ({
    presentOwner,
    lastOwner,
    width = 100,
    // dynamicQrcode,
  }) => {
    const footerDiv = document.createElement("div");
    footerDiv.style.width = `${width}%`;
    footerDiv.style.height = `${6}rem`;
    footerDiv.style.objectFit = "cover";
    footerDiv.style.boxSizing = "border-box";
    footerDiv.style.background = "#1f2329";
    footerDiv.style.borderRadius = "10px";
    footerDiv.style.color = "#fff";
    footerDiv.style.fontFamily = "'Poppins', sans-serif";
    footerDiv.style.position = "relative";
    footerDiv.style.zIndex = 10;

    const dynamicQrcode = responseData.qrcode;
    const qrBase64 = await fetchQR(dynamicQrcode);

    footerDiv.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 5px 5px 0px; width: 100%; height: 6rem;">
      <div style="height: 6rem; padding-top: 1rem; padding-left: 1.2rem;">
        <p style="margin: 0; font-size: 14px; height: 1.5rem;"><span style="color: #39b8b8;">Present Owner :</span> <strong>${presentOwner}</strong></p>
        <p style="margin: 0; font-size: 14px; height: 1.5rem;"><span style="color: #39b8b8;">Last Owner :</span> <strong>${"NA"}</strong></p>
      </div>

      <div style="width: 40%; flex-grow: 1; display: flex; justify-content: center; align-items: center; margin: 0 10px;">
        <input type="text" style="height: 2.5rem; min-width: 380px; border-radius: 8px; border: none; padding: 6px 1rem;" color: white; font-size: 14px;" value="${IMAGE_PROXY_URL}/media/${dynamicQrcode}" />
        <img src="/images/icons/icon-verified.svg" alt="Verified" style="width: 1.5rem; height: 1.5rem; margin-left: 10px;" />
      </div>

      <div style="margin-right: -1.2rem;">
        <img src="${qrBase64}" alt="QR Code" style="width: 5rem; min-height: 5rem; border-radius: 5px;" />
      </div>

      <div style="display: flex; align-items: center; justify-content: center;">
        <div style="transform: rotate(-90deg); margin-right: 1rem; font-size: 0.75rem; letter-spacing: 1px;">
            docur.io
        </div>
      </div>
    </div>
  `;

    document.body.appendChild(footerDiv);

    const canvas = await html2canvas(footerDiv, {
      useCORS: true,
      scale: 2,
      backgroundColor: null,
    });

    document.body.removeChild(footerDiv);
    return canvas;
  };
  // 🔹 helper function: convert blob → base64 for jsPDF

  const handleSubmit = async () => {
    setIsLoading(true);
    const token = JSON.parse(localStorage.getItem("token")) || null;

    try {
      const filename = fileData?.file?.name?.toLowerCase() || "";
      const imageExtensions = ["png", "jpg", "jpeg", "svg", "gif", "webp"];
      const ext = filename.split(".").pop().toLowerCase();
      let uploadBlob;
      let uploadName = fileData?.file?.name;

      // Generate footer canvas once
      const footerCanvas = await renderFooterCanvas({
        presentOwner: userNameStore, // replace with actual owner
        lastOwner: "NA", // replace with actual last owner or default
        width: 100,
        dynamicQrcode: responseData.qrcode,
      });
      const footerDataUrl = footerCanvas.toDataURL("image/png");

      if (!finalDocUrl?.length && filename.endsWith(".pdf")) {
        // PDF file directly uploaded, add footer to each page
        const pdf = new jsPDF("p", "pt", "a4");
        // const pdfDoc = await PDFLib.PDFDocument.load(await fileData.file.arrayBuffer());
        const pdfDoc = await PDFDocument.load(
          await fileData.file.arrayBuffer()
        );

        const footerImageBytes = await fetch(footerDataUrl).then((res) =>
          res.arrayBuffer()
        );
        const footerImage = await pdfDoc.embedPng(footerImageBytes);

        const pages = pdfDoc.getPages();
        const pageWidth = pdfDoc.getPage(0).getWidth();
        const pageHeight = pdfDoc.getPage(0).getHeight();
        const footerHeight =
          footerCanvas.height * (pageWidth / footerCanvas.width);

        for (let i = 0; i < pages.length; i++) {
          const page = pages[i];
          // Draw original page content
          // Then draw footer image at bottom
          page.drawImage(footerImage, {
            x: 0,
            y: 0, // bottom of page
            width: pageWidth,
            height: footerHeight,
          });
        }

        const pdfBytes = await pdfDoc.save();
        uploadBlob = new Blob([pdfBytes], { type: "application/pdf" });
        uploadName = uploadName.replace(/\.[^/.]+$/, "") + ".pdf";
      } else if (!finalDocUrl?.length && imageExtensions.includes(ext)) {
        // Create ImageBitmap for original image and footer canvas
        const originalImage = await createImageBitmap(fileData.file);
        const footerImage = await createImageBitmap(footerCanvas);

        // Calculate scale factor to match footer width to original image width
        const scale = originalImage.width / footerImage.width;
        const footerWidth = originalImage.width;
        const footerHeight = footerImage.height * scale;

        // Create a canvas with combined height
        const canvas = document.createElement("canvas");
        canvas.width = originalImage.width;
        canvas.height = originalImage.height + footerHeight;

        const ctx = canvas.getContext("2d");

        // Draw original image at top
        ctx.drawImage(
          originalImage,
          0,
          0,
          originalImage.width,
          originalImage.height
        );

        // Draw scaled footer image below original image
        ctx.drawImage(
          footerImage,
          0,
          originalImage.height,
          footerWidth,
          footerHeight
        );

        // Convert canvas to blob (PNG)
        // const combinedBlob = await new Promise(resolve => canvas.toBlob(resolve, "image/png"));
        const combinedBlob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/jpeg", 0.95)
        );

        uploadBlob = combinedBlob;
        uploadName = uploadName.replace(/\.[^/.]+$/, "") + ".png";
      } else if (finalDocUrl?.length && imageExtensions.includes(ext)) {
        // For blob URLs, fetch and combine with footer similarly
        const response = await fetch(finalDocUrl[0]);
        const imgBlob = await response.blob();
        // Create ImageBitmap for original image and footer canvas
        const originalImage = await createImageBitmap(fileData.file);
        const footerImage = await createImageBitmap(footerCanvas);

        // Calculate scale factor to match footer width to original image width
        const scale = originalImage.width / footerImage.width;
        const footerWidth = originalImage.width;
        const footerHeight = footerImage.height * scale;

        // Create a canvas with combined height
        const canvas = document.createElement("canvas");
        canvas.width = originalImage.width;
        canvas.height = originalImage.height + footerHeight;

        const ctx = canvas.getContext("2d");

        // Draw original image at top
        ctx.drawImage(
          originalImage,
          0,
          0,
          originalImage.width,
          originalImage.height
        );

        // Draw scaled footer image below original image
        ctx.drawImage(
          footerImage,
          0,
          originalImage.height,
          footerWidth,
          footerHeight
        );

        // Convert canvas to blob (PNG)
        // const combinedBlob = await new Promise(resolve => canvas.toBlob(resolve, "image/png"));
        const combinedBlob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/jpeg", 0.95)
        );

        uploadBlob = combinedBlob;
        uploadName = uploadName.replace(/\.[^/.]+$/, "") + ".png";
      } else if (finalDocUrl?.length && filename.endsWith(".pdf")) {
        // Multiple images to PDF with footer on each page
        const pdf = new jsPDF("p", "pt", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const footerImage = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.src = footerDataUrl;
        });

        const footerHeight =
          (footerImage.height * pageWidth) / footerImage.width;

        for (let i = 0; i < finalDocUrl.length; i++) {
          if (i > 0) pdf.addPage();

          const resp = await fetch(finalDocUrl[i]);
          const imgBlob = await resp.blob();
          const imgData = await toBase64(imgBlob);

          // Add main image
          pdf.addImage(
            imgData,
            "PNG",
            0,
            0,
            pageWidth,
            pageHeight - footerHeight
          );

          // Add footer at bottom
          pdf.addImage(
            footerDataUrl,
            "PNG",
            0,
            pageHeight - footerHeight,
            pageWidth,
            footerHeight
          );
        }
        uploadBlob = pdf.output("blob");
        uploadName = uploadName.replace(/\.[^/.]+$/, "") + ".pdf";
      }

      // Then upload as before
      const formData = new FormData();
      formData.append("id", responseData.id);
      formData.append("user", responseData.user);
      formData.append("file", uploadBlob, uploadName);
      formData.append("qrcode", responseData.qrcode);
      formData.append(
        "permission",
        isActive === "priv"
          ? "Private"
          : isActive === "pub"
          ? "Public"
          : permission
      );

      const res = await axios.patch(
        `${POST_UPLOAD_DOCUMENTS}/${responseData.id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.status === 201) {
        toast.success("File successfully uploaded", { autoClose: 1500 });
        dispatch({ type: DOC_UPLOAD_SUCCESS, payload: res.data });
         setTimeout(() => navigate("/documents"), 1000);
      } else if (res.status === 413) {
        toast.error("File too large, please upload again", { autoClose: 1500 });
         setTimeout(() => navigate("/upload-document"), 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network issue, Please try again.", { autoClose: 1500 });
       setTimeout(() => navigate("/upload-document"), 1000);
    } finally {
      setIsLoading(false);
    }
  };

  const toBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

  console.log(state, "sssssssss");

  return (
    <main className="page-layout page-layout--dashboard">
      <TopNavBar />
      <article className="w-100 px-0 content-layout">
        <div className="mt-2 content-layout__inner">
          <SideNavBar />
          <div className="w-100 blurred-widget-block grid-side-section">
            <div className="grid-side-section__left">
              <div className="title-row">
                <h6 className="grayText fw500 fz14 text-uppercase mb-0 lh-1 step-num-label">
                  Step 3
                </h6>
                <h2 className="text-capitalize font-secondary fz34 fw800">
                  Final Document Preview
                </h2>
              </div>

              <div className="blurred-widget-block bdr-gray table-area">
                <div className="table-title-bar">
                  <div className="table-title-bar__left">
                    <h4 className="mb-0 lh1-5 font-secondary fz16 fw600">
                      Upload Documents
                    </h4>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table mb-0 custom-dataTable">
                    <thead>
                      <tr>
                        <th>
                          <div className="fz12 fw400 grayText">
                            <img
                              src="/images/icons/icon-th-name.svg"
                              alt="Name"
                            />
                            <span>Name</span>
                          </div>
                        </th>
                        <th>
                          <div className="fz12 fw400 grayText">
                            <img
                              src="/images/icons/icon-th-type.svg"
                              alt="type"
                            />
                            <span>Type</span>
                          </div>
                        </th>
                        <th>
                          <div className="fz12 fw400 grayText">
                            <img
                              src="/images/icons/icon-calender.svg"
                              alt="calendar"
                            />
                            <span>Privacy Settings</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span>
                            {fileData?.file?.name ? fileData?.file?.name : "NA"}
                          </span>
                        </td>
                        <td>
                          <div className="p-instructions">
                            {fileData?.file?.name
                              ?.split(".")
                              ?.pop()
                              ?.toLowerCase() === "jpg" ? (
                              <span className="text-uppercase text-center p-instructions__format fz10 fw600 text-white p-instructions__format--jpg">
                                .{fileData?.file?.name?.split(".").pop()}
                              </span>
                            ) : fileData?.file?.name
                                ?.split(".")
                                .pop()
                                ?.toLowerCase() === "pdf" ? (
                              <span className="text-uppercase text-center p-instructions__format fz10 fw600 text-white p-instructions__format--png">
                                .{fileData?.file?.name?.split(".").pop()}
                              </span>
                            ) : (
                              <span className="text-uppercase text-center p-instructions__format fz10 fw600 text-white p-instructions__format--docx">
                                .{fileData?.file?.name?.split(".").pop()}
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="dropdown">
                            <button
                              className={`border-0 p-0 btn dropdown-toggle select-privacy ${
                                isActive === "priv" ? "active" : ""
                              }`}
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              {isActive === "priv" ? (
                                <img
                                  src="/images/icons/icon-user-red.svg"
                                  alt=""
                                />
                              ) : permission === "Private" ? (
                                <img
                                  src="/images/icons/icon-user-red.svg"
                                  alt=""
                                />
                              ) : (
                                <img
                                  src="/images/icons/icon-multi-users-green-dark.svg"
                                  alt=""
                                />
                              )}
                              <span className="fz12">
                                {isActive === "priv"
                                  ? "Private"
                                  : permission
                                  ? permission
                                  : "Public"}
                              </span>
                              <img
                                className="ts03 arrow"
                                src="/images/icons/icon-table-dd-arrow.svg"
                                alt=""
                              />
                            </button>
                            <div className="blurred-widget-block bdr-gray blur-7 dropdown-menu dropdown-menu--privacy">
                              <ul className="mb-0 overflow-hidden blurred-widget-block bdrs12 list-unstyled">
                                <li>
                                  <a
                                    className={`fz12 ${
                                      isActive === "priv" ? "active" : ""
                                    }`}
                                    onClick={() => {
                                      handleActive("priv");
                                    }}
                                  >
                                    <b>
                                      <img
                                        src="/images/icons/icon-user-red.svg"
                                        alt=""
                                      />
                                    </b>
                                    <span className="">Private</span>
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className={`fz12 ${
                                      isActive === "pub" ? "active" : ""
                                    }`}
                                    onClick={() => {
                                      handleActive("pub");
                                    }}
                                  >
                                    <b>
                                      <img
                                        src="/images/icons/icon-multi-users-green-dark.svg"
                                        alt=""
                                      />
                                    </b>
                                    <span className="">Public</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="bottom-content-wrapper">
                    <div className="bottom-content">
                      {isLoading ? (
                        <div className="loader-wrapper">
                          <p>Loading preview...</p>
                          {/* Replace with a spinner if needed */}
                        </div>
                      ) : finalDocUrl ? (
                        <div className="pdf-scroll-container">
                          {finalDocUrl.map((url, index) => (
                            <div className="pdf-page-container" key={index}>
                              <img
                                src={url}
                                alt={`Modified Page ${index + 1}`}
                              />
                              <DocFooter
                                responseData={responseData}
                                presentOwner={userNameStore}
                                lastOwner="NA"
                              />
                            </div>
                          ))}
                        </div>
                      ) : isPDF ? (
                        // Original PDF Preview
                        <div className="pdf-scroll-container">
                          {previewImage?.length > 0 ? (
                            previewImage.map((page, index) => (
                              <div key={index} className="pdf-page-container">
                                <img
                                  src={page}
                                  alt={`PDF page ${index + 1}`}
                                  className="image-micotext"
                                />
                                <DocFooter
                                  responseData={responseData}
                                  presentOwner={userNameStore}
                                  lastOwner="NA"
                                />
                              </div>
                            ))
                          ) : (
                            <p>No pages to display.</p>
                          )}
                        </div>
                      ) : isImage ? (
                        // <div>
                        //   <img
                        //     src={
                        //       fileData?.file?.name
                        //         ? URL.createObjectURL(fileData?.file)
                        //         : "path_to_placeholder_image"
                        //     }
                        //     alt="Uploaded file"
                        //     className="image-micotext"
                        //   />
                        //   <DocFooter
                        //     responseData={responseData}
                        //     presentOwner="vinit chauhan"
                        //     lastOwner="arpit srivastava"
                        //   />
                        // </div>
                        <div>
                          <img
                            src={previewImage[0]}
                            alt="Uploaded file"
                            className="image-micotext"
                          />
                          <DocFooter
                            responseData={responseData}
                            presentOwner={userNameStore}
                            lastOwner="NA"
                          />
                        </div>
                      ) : previewImage ? (
                        <div className="word-document-preview">
                          <div
                            className="a4-page"
                            dangerouslySetInnerHTML={{ __html: previewImage }}
                          />
                        </div>
                      ) : (
                        <div />
                      )}
                    </div>
                  </div>
                  <div className="issuer-select-btn">
                    <button
                      className="text-uppercase bdrs10 fw600 fz10 btn btn-solid btn-solid--dark issuer-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#create-microtext"
                      onClick={handleMicrotextClick}
                    >
                      Microtext
                      {selectMicrotext && (
                        <img
                          src="/images/icons/icon-doubletick-selected.svg"
                          alt="icon-doubletick-selected"
                          className="tick-icon"
                        />
                      )}
                    </button>
                    <button
                      className="text-uppercase bdrs10 fw600 fz10 btn btn-solid btn-solid--dark issuer-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#create-watermark"
                      onClick={handleWatermarkClick}
                    >
                      Watermark
                      {selectWatermark && (
                        <img
                          src="/images/icons/icon-doubletick-selected.svg"
                          alt="icon-doubletick-selected"
                          className="tick-icon"
                        />
                      )}
                    </button>
                    {finalDocUrl ? (
                      <button
                        className="text-uppercase bdrs10 fw600 fz10 btn btn-solid btn-solid--dark issuer-btn"
                        onClick={(e) => handleRemoveOption(e)}
                      >
                        Remove
                      </button>
                    ) : (
                      <span></span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <DashboardSidebar handleNext={handleSubmit} />
          </div>
        </div>
      </article>
      <ToastContainer />
      <Microtext
        file={fileData?.file}
        startLoader={() => setIsLoading(true)}
        stopLoader={() => setIsLoading(false)}
        onDone={(blobs) => {
          if (!Array.isArray(blobs)) {
            setIsLoading(false);
            return;
          }

          const urls = blobs.map((blob) => URL.createObjectURL(blob));
          setFinalDocUrl(urls);
          setIsLoading(false);
        }}
      />

      <Watermark
        file={fileData?.file}
        startLoader={() => setIsLoading(true)}
        stopLoader={() => setIsLoading(false)}
        onDone={(blobs) => {
          if (!Array.isArray(blobs)) {
            setIsLoading(false);
            return;
          }

          const urls = blobs.map((blob) => URL.createObjectURL(blob));
          setFinalDocUrl(urls);
          setIsLoading(false);
        }}
      />
      <Loader show={isLoading} />
    </main>
  );
}
